import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Abre/cierra un detalle flotante con retardo para evitar parpadeos al cruzar el puntero.
 */
export const useDeferredHover = ({ showDelay = 80, hideDelay = 200 } = {}) => {
    const [hover, setHover] = useState(null);
    const showTimerRef = useRef(null);
    const hideTimerRef = useRef(null);

    const clearHoverTimers = useCallback(() => {
        window.clearTimeout(showTimerRef.current);
        window.clearTimeout(hideTimerRef.current);
        showTimerRef.current = null;
        hideTimerRef.current = null;
    }, []);

    useEffect(() => () => clearHoverTimers(), [clearHoverTimers]);

    const openHover = useCallback((event, target) => {
        if (!event || !target) return;
        clearHoverTimers();
        const rect = target.getBoundingClientRect();
        showTimerRef.current = window.setTimeout(() => {
            setHover({ event, rect });
        }, showDelay);
    }, [clearHoverTimers, showDelay]);

    const keepHover = useCallback(() => {
        window.clearTimeout(hideTimerRef.current);
        hideTimerRef.current = null;
    }, []);

    const closeHover = useCallback(() => {
        window.clearTimeout(showTimerRef.current);
        hideTimerRef.current = window.setTimeout(() => {
            setHover(null);
        }, hideDelay);
    }, [hideDelay]);

    const dismissHover = useCallback(() => {
        clearHoverTimers();
        setHover(null);
    }, [clearHoverTimers]);

    return {
        hover,
        openHover,
        keepHover,
        closeHover,
        dismissHover,
    };
};
